import { render, staticRenderFns } from "./requests-description-column.vue?vue&type=template&id=32ce1eb0"
import script from "./requests-description-column.vue?vue&type=script&lang=js"
export * from "./requests-description-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports